import { api } from './client';

export const complianceApi = {
  // === 징계 관리 ===
  getDisciplinaryConstants: async (): Promise<any> => {
    const response = await api.get('/api/disciplinary/constants');
    return response.data;
  },

  getDisciplinarySummary: async (): Promise<any> => {
    const response = await api.get('/api/disciplinary/summary');
    return response.data;
  },

  getDisciplinaryCases: async (status?: string, limit: number = 50, offset: number = 0): Promise<any> => {
    const params: any = { limit, offset };
    if (status) params.status = status;
    const response = await api.get('/api/disciplinary/cases', { params });
    return response.data;
  },

  getDisciplinaryCase: async (caseId: number): Promise<any> => {
    const response = await api.get(`/api/disciplinary/cases/${caseId}`);
    return response.data;
  },

  createDisciplinaryCase: async (data: any): Promise<any> => {
    const response = await api.post('/api/disciplinary/cases', data);
    return response.data;
  },

  updateDisciplinaryCase: async (caseId: number, data: any): Promise<any> => {
    const response = await api.patch(`/api/disciplinary/cases/${caseId}`, data);
    return response.data;
  },

  transitionDisciplinaryStatus: async (caseId: number, status: string): Promise<any> => {
    const response = await api.post(`/api/disciplinary/cases/${caseId}/transition`, { status });
    return response.data;
  },

  scheduleDisciplinaryHearing: async (caseId: number, data: any): Promise<any> => {
    const response = await api.post(`/api/disciplinary/cases/${caseId}/hearings`, data);
    return response.data;
  },

  completeDisciplinaryHearing: async (hearingId: number, data: any): Promise<any> => {
    const response = await api.post(`/api/disciplinary/hearings/${hearingId}/complete`, data);
    return response.data;
  },

  createDisciplinaryDecision: async (caseId: number, data: any): Promise<any> => {
    const response = await api.post(`/api/disciplinary/cases/${caseId}/decisions`, data);
    return response.data;
  },

  notifyDisciplinaryDecision: async (decisionId: number): Promise<any> => {
    const response = await api.post(`/api/disciplinary/decisions/${decisionId}/notify`);
    return response.data;
  },

  appealDisciplinaryDecision: async (decisionId: number, reason: string): Promise<any> => {
    const response = await api.post(`/api/disciplinary/decisions/${decisionId}/appeal`, { reason });
    return response.data;
  },

  executeDisciplinaryCase: async (caseId: number): Promise<any> => {
    const response = await api.post(`/api/disciplinary/cases/${caseId}/execute`);
    return response.data;
  },

  closeDisciplinaryCase: async (caseId: number): Promise<any> => {
    const response = await api.post(`/api/disciplinary/cases/${caseId}/close`);
    return response.data;
  },

  addDisciplinaryComment: async (caseId: number, content: string, isInternal: boolean = true): Promise<any> => {
    const response = await api.post(`/api/disciplinary/cases/${caseId}/comments`, { content, is_internal: isInternal });
    return response.data;
  },

  // === 괴롭힘 신고 (BACK-081) ===
  createHarassmentReport: async (data: any): Promise<any> => {
    const response = await api.post('/api/harassment', data);
    return response.data;
  },

  getHarassmentReports: async (status?: string, limit?: number, offset?: number): Promise<any> => {
    const params: any = {};
    if (status) params.status = status;
    if (limit) params.limit = limit;
    if (offset) params.offset = offset;
    const response = await api.get('/api/harassment', { params });
    return response.data;
  },

  getHarassmentReport: async (id: number): Promise<any> => {
    const response = await api.get(`/api/harassment/${id}`);
    return response.data;
  },

  getHarassmentStats: async (): Promise<any> => {
    const response = await api.get('/api/harassment/stats');
    return response.data;
  },

  getHarassmentTypes: async (): Promise<any> => {
    const response = await api.get('/api/harassment/types');
    return response.data;
  },

  getMyHarassmentReports: async (): Promise<any> => {
    const response = await api.get('/api/harassment/my');
    return response.data;
  },

  updateHarassmentStatus: async (id: number, data: any): Promise<any> => {
    const response = await api.put(`/api/harassment/${id}/status`, data);
    return response.data;
  },

  addHarassmentAction: async (id: number, data: any): Promise<any> => {
    const response = await api.post(`/api/harassment/${id}/actions`, data);
    return response.data;
  },
};
